import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type ScenarioLegPhotosQueryVariables = Types.Exact<{
  moveId: Types.Scalars['bigint']['input'];
  isPickup: Types.Scalars['Boolean']['input'];
  isDelivery: Types.Scalars['Boolean']['input'];
}>;


export type ScenarioLegPhotosQuery = { __typename?: 'query_root', moves_by_pk?: { __typename?: 'moves', id: number, pickup_workflow_data?: object | null, delivery_workflow_data?: object | null, pickup_photos?: Array<{ __typename?: 'vehiclephotos', id: string, location?: object | null, name: string, step_id: string, url?: string | null }>, delivery_photos?: Array<{ __typename?: 'vehiclephotos', id: string, location?: object | null, name: string, step_id: string, url?: string | null }>, workflowset?: { __typename?: 'workflowsets', id: number, pickupWorkflow?: { __typename?: 'workflows', id: number, steps: object } | null, deliveryWorkflow?: { __typename?: 'workflows', id: number, steps: object } | null } | null } | null };


export const ScenarioLegPhotosDocument = gql`
    query scenarioLegPhotos($moveId: bigint!, $isPickup: Boolean!, $isDelivery: Boolean!) {
  moves_by_pk(id: $moveId) {
    id
    pickup_workflow_data @include(if: $isPickup)
    delivery_workflow_data @include(if: $isDelivery)
    pickup_photos: vehiclephotos(where: {workflow: {type: {_eq: "pickup"}}}) @include(if: $isPickup) {
      id
      location
      name
      step_id
      url
    }
    delivery_photos: vehiclephotos(where: {workflow: {type: {_eq: "delivery"}}}) @include(if: $isDelivery) {
      id
      location
      name
      step_id
      url
    }
    workflowset {
      id
      pickupWorkflow @include(if: $isPickup) {
        id
        steps
      }
      deliveryWorkflow @include(if: $isDelivery) {
        id
        steps
      }
    }
  }
}
    `;

/**
 * __useScenarioLegPhotosQuery__
 *
 * To run a query within a React component, call `useScenarioLegPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenarioLegPhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenarioLegPhotosQuery({
 *   variables: {
 *      moveId: // value for 'moveId'
 *      isPickup: // value for 'isPickup'
 *      isDelivery: // value for 'isDelivery'
 *   },
 * });
 */
export function useScenarioLegPhotosQuery(baseOptions: Apollo.QueryHookOptions<ScenarioLegPhotosQuery, ScenarioLegPhotosQueryVariables> & ({ variables: ScenarioLegPhotosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScenarioLegPhotosQuery, ScenarioLegPhotosQueryVariables>(ScenarioLegPhotosDocument, options);
      }
export function useScenarioLegPhotosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScenarioLegPhotosQuery, ScenarioLegPhotosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScenarioLegPhotosQuery, ScenarioLegPhotosQueryVariables>(ScenarioLegPhotosDocument, options);
        }
// @ts-ignore
export function useScenarioLegPhotosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScenarioLegPhotosQuery, ScenarioLegPhotosQueryVariables>): Apollo.UseSuspenseQueryResult<ScenarioLegPhotosQuery, ScenarioLegPhotosQueryVariables>;
export function useScenarioLegPhotosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScenarioLegPhotosQuery, ScenarioLegPhotosQueryVariables>): Apollo.UseSuspenseQueryResult<ScenarioLegPhotosQuery | undefined, ScenarioLegPhotosQueryVariables>;
export function useScenarioLegPhotosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScenarioLegPhotosQuery, ScenarioLegPhotosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScenarioLegPhotosQuery, ScenarioLegPhotosQueryVariables>(ScenarioLegPhotosDocument, options);
        }
export type ScenarioLegPhotosQueryHookResult = ReturnType<typeof useScenarioLegPhotosQuery>;
export type ScenarioLegPhotosLazyQueryHookResult = ReturnType<typeof useScenarioLegPhotosLazyQuery>;
export type ScenarioLegPhotosSuspenseQueryHookResult = ReturnType<typeof useScenarioLegPhotosSuspenseQuery>;
export type ScenarioLegPhotosQueryResult = Apollo.QueryResult<ScenarioLegPhotosQuery, ScenarioLegPhotosQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/components/ScenarioPhotoLightbox/queries/scenarioLegPhotos.query.gql}
 */
export async function scenarioLegPhotos(
  variables: ScenarioLegPhotosQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<ScenarioLegPhotosQuery['moves_by_pk']>
export async function scenarioLegPhotos(
  variables: ScenarioLegPhotosQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<ScenarioLegPhotosQuery>
export async function scenarioLegPhotos(
  variables: ScenarioLegPhotosQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<ScenarioLegPhotosQuery['moves_by_pk'] | ScenarioLegPhotosQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<ScenarioLegPhotosQuery>(
    ScenarioLegPhotosDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.moves_by_pk
}